export const gatewayDirection = { diverging: 'Diverging', converging: 'Converging' };
